import { Col, Row, Typography } from "antd";
import React from "react";
import { useFormContext } from "react-hook-form";
import { SelectOption } from "../../../../../types/select";
import { DateField, InputField, ReactSelectField, TextAreaField } from "../../../../atoms/FormElement";
import { InputNumberFieldV2 as InputNumberField } from "../../../../atoms/FormElement/InputNumberField";
import { getValidationProps } from "../../../../libs/form";
import { paymentModeOptions } from "../../utili";

const { Text } = Typography;

type ReplacementChequeFieldsProps = {
  banksOptions: SelectOption[];
  depositToOptions: SelectOption[];
  disabled?: boolean;
};

export const ReplacementChequeFields = (props: ReplacementChequeFieldsProps) => {
  const { banksOptions, depositToOptions, disabled } = props;
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const validationProps = (fieldName: string) =>
    disabled ? {} : getValidationProps({ fieldName, errors, isRequired: true });

  return (
    <>
      <Text strong style={{ fontSize: 15, display: "block", marginBottom: 16 }}>
        Replacement cheque details
      </Text>

      <Row gutter={24}>
        <Col span={12}>
          <ReactSelectField
            isRequired={!disabled}
            fieldname="paymentMode"
            label="Payment mode"
            control={control}
            selectOption={paymentModeOptions}
            iProps={{ isDisabled: disabled }}
            {...validationProps("paymentMode")}
          />
        </Col>
        <Col span={12}>
          <InputNumberField
            isRequired={!disabled}
            fieldname="amountToPay"
            label="Amount to pay"
            format="currency"
            control={control}
            disabled={disabled}
          />
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <InputField
            isRequired={!disabled}
            fieldname="paymentRef"
            label="Payment ref"
            control={control}
            disabled={disabled}
            {...validationProps("paymentRef")}
          />
        </Col>
        <Col span={12}>
          <ReactSelectField
            isRequired={!disabled}
            fieldname="bankName"
            label="Bank name"
            control={control}
            selectOption={banksOptions}
            iProps={{ isDisabled: disabled }}
            {...validationProps("bankName")}
          />
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <DateField
            isRequired={!disabled}
            fieldname="paidDate"
            label="Cheque date"
            control={control}
            disabled={disabled}
            {...validationProps("paidDate")}
          />
        </Col>
        <Col span={12}>
          <DateField fieldname="depositDate" label="Deposit date" control={control} disabled={disabled} />
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <ReactSelectField
            fieldname="depositTo"
            label="Deposit to"
            control={control}
            selectOption={depositToOptions}
            iProps={{ isDisabled: disabled }}
          />
        </Col>
        <Col span={12}>
          <ReactSelectField
            fieldname="depositBank"
            label="Deposit bank"
            control={control}
            selectOption={banksOptions}
            iProps={{ isDisabled: disabled }}
          />
        </Col>
      </Row>

      <TextAreaField
        isRequired={!disabled}
        fieldname="recallReason"
        label="Recall reason"
        control={control}
        disabled={disabled}
        iProps={{ placeholder: "Enter reason for recalling this cheque...", rows: 2 }}
        {...validationProps("recallReason")}
      />
    </>
  );
};
